export default () => {
  const startsWithQuery = (items, query) => items.reduce((collection, item) => {
    if (item.title.toLowerCase().indexOf(query.toLowerCase()) === 0) {
      collection.push(item);
    }
    return collection;
  }, []);
  const containsQuery = (items, query) => items.reduce((collection, item) => {
    if (item.title.toLowerCase().indexOf(query.toLowerCase()) > 0) {
      collection.push(item);
    }
    return collection;
  }, []);
  const filter = (items, query) => [...startsWithQuery(items, query), ...containsQuery(items, query)];

  $('.autocomplete--estates').each((index, input) => {
    const $input = $(input);
    const $wrapper = $input.closest('form');
    const $valueInput = $('[name="ItemId"]', $wrapper);
    const $submitButton = $('[type="submit"]', $wrapper);
    let first = null;
    $input.autocomplete({
      source: [{
        url: $input.data('src'),
        type: 'remote'
      }],
      valueKey: 'title',
      titleKey: 'title',
      minLength: 2,
      visibleLimit: 6,
      limit: 100,
      autoselect: true,
      highlight: true,
      showHint: false,
      getValue: ({ title, url }) => {
        $input.val(title);
        $valueInput.val(url);
        return title;
      },
      render: ({ title, url, level }, source, pid, query) => (
        `<div class="autocomplete-item autocomplete-item--level-${level}" ${(title === query ? 'class="active"' : '')} data-value="${url}">${title}</div>`
      ),
      filter: (items, query) => {
        const filtered = filter(items, query);
        first = filtered[0] || {};
        $valueInput.val(null);
        return filtered;
      }
    }).on('selected.xdsoft', (e, { title, url }) => {
      $submitButton.focus();
      $valueInput.val(url);
      $input.val(title);
    }).on('blur', () => {
      if (first && !$valueInput.val()) {
        $valueInput.val(first.url);
        $input.val(first.title);
      }
    });

    return $input;
  });
};
